import { sortParamToQuery } from '@/api';

// TODO:
export default function quiz(axios: any) {
  const getQuizzes = async (
    liveId: number,
    page = 1,
    perPage = 30,
    sort: { field: string; order: string },
    filterByName = '',
  ) => {
    const result = await axios.get(`/sessions/${liveId}/quizzes?page[number]=${page}&page[size]=${perPage}${sortParamToQuery(sort)}&filterName=${filterByName}`)
      .then((response: any) => {
        if (response.status === 200) {
          return response.data.data;
        }
        return response;
      });
    return result;
  };

  const getQuiz = async (
    id: number,
  ) => {
    const result = await axios.get(`/quizzes/${id}`).then((response: any) => {
      if (response.status === 200) {
        return response.data.data;
      }
      return response;
    });
    return result;
  };

  const createQuiz = async (
    liveId: number | string, // Actually is Session id
    payload: {
      name: string;
      active_for_seconds: number;
      text: string;
      quiz_choices: { id?: number; text: string; correct?: boolean }[];
    },
  ) => {
    const result = await axios.post(`/sessions/${liveId}/create-quiz`, payload).then((response: any) => {
      if (response.status === 200) {
        return response.data;
      }
      return response;
    });
    return result;
  };

  const updateQuiz = async (
    id: number,
    payload: {
      name: string;
      active_for_seconds: number;
      text: string;
      quiz_choices: { id?: number; text: string; correct: boolean; }[];
      deleteChoices: number[] | undefined;
    },
  ) => {
    const result = await axios.put(`/quizzes/${id}`, payload).then((response: any) => {
      if (response.status === 200) {
        return response.data;
      }
      return response;
    });
    return result;
  };

  const controlQuiz = async (
    liveId: number,
    quizId: number | null,
  ) => {
    const result = await axios.put(`/sessions/${liveId}`, {
      /* eslint-disable */
      active_quiz_id: quizId,
      /* eslint-enable */
    }).then((response: any) => {
      if (response.status === 200) {
        return response.data.data.session.active_quiz_id;
      }
      return response;
    });
    return result;
  };

  const deleteQuiz = async (
    id: number,
  ) => {
    const result = await axios.post('/quizzes/delete', {
      ids: [id],
    }).then((response: any) => {
      if (response.status === 200) {
        return response.data;
      }
      return response;
    });
    return result;
  };

  const deleteQuizzes = async (
    ids: number[],
  ) => {
    // const params = deleteIdsToQuery(ids);
    const result = await axios.post('/quizzes/delete', {
      ids,
    }).then((response: any) => {
      if (response.status === 200) {
        return response.data;
      }
      return response;
    });
    return result;
  };

  const getLeaderboards = async () => {
    const result = await axios.get('/quizzes/leaderboard?sort=-score&page[size]=200')
      .then((response: any) => {
        if (response.status === 200) {
          return response.data.data;
        }
        return response;
      });
    return result;
  };

  function createBlob(file: File, liveId: number) {
    const url = window.URL.createObjectURL(new Blob([file]));
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', `export-leaderboard-${liveId}.csv`);
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  }

  const resetLeaderboards = async (
    liveId: number,
  ) => {
    try {
      const result = await axios.post(`/sessions/${liveId}/leaderboard/reset`);
      if (result.status === 200) {
        createBlob(result.data, liveId);

        return { status: 200 };
      }
      return result;
    } catch (err) {
      console.log('[api/quiz.ts] resetLeaderboards');
    }
    return { status: 1 };
  };

  const downloadLeaderboardAsCSV = async (
    liveId: number,
    quizId?: number,
  ) => {
    try {
      let endpoint = `/sessions/${liveId}/leaderboard/csv`;
      if (quizId) endpoint = `${endpoint}?quiz_id=${quizId}`;

      const result = await axios.post(endpoint);
      if (result.status === 200) {
        createBlob(result.data, liveId);

        return result.data;
      }
      return result;
    } catch (err) {
      console.log('[api/quiz.ts] downloadLeaderboardAsCSV');
    }
    return { status: 1 };
  };

  return {
    getQuizzes,
    getQuiz,
    createQuiz,
    updateQuiz,
    controlQuiz,
    deleteQuiz,
    deleteQuizzes,
    getLeaderboards,
    resetLeaderboards,
    downloadLeaderboardAsCSV,
  };
}
